/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceStepResponseEmailSubjectMode = typeof SequenceStepResponseEmailSubjectMode[keyof typeof SequenceStepResponseEmailSubjectMode] | null;


export const SequenceStepResponseEmailSubjectMode = {
  static: 'static',
  ai_generated: 'ai_generated',
} as const;
